/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/application_flow/application_flow';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "CancelApplicationFlowRequest": {
                "fields": {
                  "applicationFlowId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cancelReason": {
                    "type": ".squareup.corporate_card.service.CancelApplicationFlowRequest.CancelReason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cancelReasonDetail": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CancelReason": {
                    "values": {
                      "CANCEL_REASON_DO_NOT_USE": 0,
                      "CANCEL_REASON_UPDATE_PERSONAL": 1,
                      "CANCEL_REASON_UPDATE_BUSINESS": 2,
                      "CANCEL_REASON_OTHER": 100
                    }
                  }
                }
              },
              "CancelApplicationFlowResponse": {
                "fields": {
                  "applicationFlow": {
                    "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CancelApplicationFlowRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CancelApplicationFlowRequest?.nested?.CancelReason && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CancelApplicationFlowResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CancelApplicationFlowRequest @ squareup/corporate_card/service/cancel_application_flow.proto at 10:1
 */
export const CancelApplicationFlowRequest = $root.lookupType('squareup.corporate_card.service.CancelApplicationFlowRequest');
fixType(CancelApplicationFlowRequest, {
  applicationFlowId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CancelApplicationFlowRequest);
/**
 * SOURCE CancelReason @ squareup/corporate_card/service/cancel_application_flow.proto at 11:3
 */
CancelApplicationFlowRequest.CancelReason = $root.lookupEnum('squareup.corporate_card.service.CancelApplicationFlowRequest.CancelReason').values;
/**
 * SOURCE CancelApplicationFlowResponse @ squareup/corporate_card/service/cancel_application_flow.proto at 37:1
 */
export const CancelApplicationFlowResponse = $root.lookupType('squareup.corporate_card.service.CancelApplicationFlowResponse');
fixType(CancelApplicationFlowResponse);
Builder.createAndAttachToType(CancelApplicationFlowResponse);